module.exports = __webpack_public_path__ + "bc30794022de5712e3d4fb5514b723aa.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/style/iconfont/iconfont.ttf
// module id = 353
// module chunks = 0 204 209